import Typography from "@portal/components/atoms/v2/typography";
import { useEffect, useState } from "react";
import { MainBox } from "../components/mainBox";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { setExperience } from "@portal/redux/reducers/riskLevelReducer";
import { MapExperienceToIndex, MapIndexToExperience } from "./helpers/MapData";
import { GetIconForExperiencePage } from "./helpers/GetIconForExperiencePage";
import { RadioGroup } from "@headlessui/react";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { setLanguage } from "@portal/redux/reducers/languageReducer";
import { IsBankNewNorwegian } from "@portal/helpers";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Button from "@portal/components/atoms/v2/buttons/button";
import { useRouter } from "next/navigation";
import { OnFooterClick } from "./handlers/OnFooterClick";
import RadioComponentWithSelectionBox from "@portal/components/atoms/v2/radioComponentWithSelectionBox";

export const ExperiencePage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { request } = useAppSelector(state => state.persisted.riskLevel);
  const [selectedOption, setSelectedOption] = useState<number | null>(MapExperienceToIndex(request.experience));
  const isButtonDisabled = request.experience === null;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_1_A, texts.PAGE_1_B, texts.PAGE_1_C];

  // Handling of centerId if the user has been redirected out of an iFrame and lost the centerId
  useEffect(() => {
    if (centerId && IsBankNewNorwegian(centerId)) {
      dispatch(setLanguage(false));
    }
  }, [dispatch, centerId]);

  const OnSelectionClick = (selectedOption: number) => {
    setSelectedOption(selectedOption);
    dispatch(setExperience(MapIndexToExperience(selectedOption)));
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_1_SUBHEADER}</Typography>
        <TextLine />
        <div className="flex flex-col my-2.5">
          <RadioGroup value={selectedOption} onChange={OnSelectionClick} className="space-y-3">
            {options.map((text, i) => (
              <RadioComponentWithSelectionBox key={i} value={i} id={i.toString()} hideRadio smallPadding>
                {GetIconForExperiencePage(i)}
                <div className="flex flex-col p-2">
                  <Typography>{text}</Typography>
                </div>
              </RadioComponentWithSelectionBox>
            ))}
          </RadioGroup>
        </div>
      </MainBox>
      <div className="flex w-full p-5 justify-between">
        <Button onClick={() => OnFooterClick(router, pageIndex, centerId)} text={texts.BUTTON_BACK} />
        <Button
          onClick={() => OnFooterClick(router, pageIndex, centerId, true)}
          text={texts.BUTTON_NEXT}
          disabled={isButtonDisabled}
          primary
        />
      </div>
    </>
  );
};
